import { Modal } from '@/components/common/dialog';
import { ModalButton } from '@/components/common/modal-button';
import { useTranslation } from 'react-i18next';

interface ZoomDialogProps {
    isOpen: boolean;
    onClose: (isCountdownClose?: boolean) => void;
    onConfirm: () => void;
}

export function ZoomDialog({ isOpen, onClose, onConfirm }: ZoomDialogProps) {
    const { t } = useTranslation();
    const modalId = 'zoom-dialog';

    return (
        <Modal modalIdInit={modalId} isOpen={isOpen} onClose={onClose} className="max-w-[calc(680*var(--vw-unit))] tts-modal">
            <div className="flex h-full flex-col">
                <header className="text-text-main01 px-[calc(56*var(--vh-unit))] pt-[calc(56*var(--vh-unit))] pb-[calc(8*var(--vh-unit))] text-[calc(58*var(--vh-unit))] leading-normal font-bold tracking-[calc(-1.276*var(--vh-unit))]">
                    <h1 data-modal-region tabIndex={0} aria-label={t('zoom.title')} data-interactive className="text-center font-bold focus-border ">
                        {t('zoom.title')}
                    </h1>
                </header>
                <main className="px-[calc(48*var(--vw-unit))] py-[calc(40*var(--vh-unit))]">
                    <div>
                        <p
                            tabIndex={0}
                            aria-label={t('zoom.ariaDescription')}
                            data-interactive
                            className="text-text-main01 text-center text-[calc(40*var(--vh-unit))] leading-[calc(50*var(--vh-unit))] font-medium tracking-[calc(-0.24*var(--vh-unit))] focus-border "
                            dangerouslySetInnerHTML={{ __html: t('zoom.description') }}
                        ></p>
                    </div>
                </main>
                <footer className="flex justify-center px-[calc(56*var(--vh-unit))] pt-[calc(24*var(--vh-unit))] pb-[calc(52*var(--vh-unit))]">
                    <ModalButton
                        role="button"
                        variant="secondary"
                        aria-label={t('zoom.text.confirmButton')}
                        onClick={onConfirm}
                        data-interactive
                        type="button"
                    >
                        {t('zoom.text.confirmButton')}
                    </ModalButton>
                </footer>
            </div>
        </Modal>
    );
}
